import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { Language } from "../../../CorporateProfile/Corporate.hook";
import { toUniqueKey } from "../../Community/MainContent/MainContent";
import { useMemorableAirportExperiences } from "../../Sustainability.hook";
import { fields, fieldsReady } from "../constants";
export const SiderData: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const {
    data: profileData,
    isLoading: isLoadingProfile,
    refetch: refetchOurProfile,
  } = useMemorableAirportExperiences();
  const {
    data: profileDataById,
    isLoading: isLoadingprofileById,
    refetch: refetchOurProfileById,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("profileDataById", profileDataById, profileData, fieldData, approveId);

  useEffect(() => {
    if (query?.get("id")) {
      setPayloadData(profileDataById?.payload);
    } else {
      setPayloadData(profileData?.[0]);
    }
  }, [profileData, profileDataById]);

  useEffect(() => {
    if (approveId) {
      refetchOurProfileById();
    } else {
      refetchOurProfile();
    }
  }, [query.get("thirdChildActiveTab"), approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);
  const createFormConfig = (name?: string, idx1?: any, field?: any): FormConfig => {
    const getMarkupValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];
      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.siderData?.[idx1]?.description);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.siderData?.[idx1]?.description);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.siderData?.[idx1]?.description);
    };
    const getTitleValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.siderData?.[idx1]?.title);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.siderData?.[idx1]?.title);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.siderData?.[idx1]?.title);
    };
    const getImageValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML([
              {
                uid: "-1",
                name: "image.png",
                status: "done",
                url: JSON.parse(payload)?.data?.siderData?.[idx1]?.image,
              },
            ]);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: payload?.data?.siderData?.[idx1]?.image,
            },
          ]);
        }
      }

      return decodeHTML([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: profileData?.[0]?.[language]?.data?.siderData?.[idx1]?.image,
        },
      ]);
    };

    return {
      initialValues: {
        [`field_content_english.data.siderData[${idx1}].image`]: getImageValue("field_content_english"),
        [`field_content_english.data.siderData[${idx1}].title`]: getTitleValue("field_content_english"),
        [`field_content_english.data.siderData[${idx1}].description`]: getMarkupValue("field_content_english"),
        [`field_content_malay.data.siderData[${idx1}].image`]: getImageValue("field_content_malay"),
        [`field_content_malay.data.siderData[${idx1}].title`]: getTitleValue("field_content_malay"),
        [`field_content_malay.data.siderData[${idx1}].description`]: getMarkupValue("field_content_malay"),
        [`field_content_mandarin.data.siderData[${idx1}].image`]: getImageValue("field_content_mandarin"),
        [`field_content_mandarin.data.siderData[${idx1}].title`]: getTitleValue("field_content_mandarin"),
        [`field_content_mandarin.data.siderData[${idx1}].description`]: getMarkupValue("field_content_mandarin"),
      },
      fields: field,
    };
  };

  const updatePayload = (data: any) => {
    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (key.includes(".")) {
          const topLevelKey = key.split(".")[0];
          if (obj[topLevelKey] && typeof obj[topLevelKey] === "object") {
            continue;
          }

          const parts = key.split(".");
          let current = result;

          for (let i = 0; i < parts.length - 1; i++) {
            current[parts[i]] = current[parts[i]] || {};
            current = current[parts[i]];
          }

          current[parts[parts.length - 1]] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }
      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key];
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }
      return result;
    };

    const mergeCardDataItem = (newItem: any, existingItem: any): any => {
      if (!newItem || Object.keys(newItem).length === 0) {
        return existingItem;
      }

      if (!existingItem) {
        return newItem;
      }

      return {
        ...existingItem,
        ...newItem,
        ...(existingItem.id && { id: existingItem.id }),
      };
    };

    const mergeArrays = (newArray: any[], existingArray: any[], path: string): any[] => {
      if (path.includes("siderData")) {
        const result = [...existingArray];
        newArray.forEach((item, index) => {
          if (item && Object.keys(item).length > 0) {
            result[index] = mergeCardDataItem(item, existingArray[index]);
          }
        });
        return result;
      }
      // For other arrays (including siderData), preserve existing data
      return existingArray;
    };

    const deepMerge = (target: any, source: any, path: string = ""): any => {
      console.log("deepMerge", target, source, path);
      const result = { ...target };

      for (const key in source) {
        const currentPath = path ? `${path}.${key}` : key;

        if (typeof source[key] === "object" && source[key] !== null) {
          if (Array.isArray(source[key])) {
            if (target[key] && Array.isArray(target[key])) {
              result[key] = mergeArrays(source[key], target[key], currentPath);
            } else {
              // Only update if not siderData
              if (!currentPath.includes("features")) {
                result[key] = source[key];
              }
            }
          } else {
            result[key] = deepMerge(target[key] || {}, source[key], currentPath);
          }
        } else if (source[key] !== undefined && !currentPath.includes("features")) {
          result[key] = source[key];
        }
      }

      return result;
    };

    const convertedData = convertDotNotation(data);
    const filteredData = filterNestedObjects(convertedData);

    const parseIfString = (data: any) => {
      try {
        return typeof data === "string" ? JSON.parse(data) : data;
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return data;
      }
    };
    console.log("parsedPayloadData", payloadData);
    const parsedPayloadData = {
      ...payloadData,
      field_content_english: parseIfString(payloadData.field_content_english),
      field_content_malay: parseIfString(payloadData.field_content_malay),
      field_content_mandarin: parseIfString(payloadData.field_content_mandarin),
    };

    const updateValue = deepMerge(parsedPayloadData, filteredData);

    return updateValue;
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const payloadDatas = await updatePayload(data);
    let imageKeys = [];
    const siderDataLength = payloadDatas.field_content_english?.data?.siderData?.length || 0;

    for (let i = 0; i < siderDataLength; i++) {
      imageKeys.push(
        `field_content_mandarin.data.siderData.${i}.image`,
        `field_content_malay.data.siderData.${i}.image`,
        `field_content_english.data.siderData.${i}.image`
      );
    }

    for (const key of imageKeys) {
      try {
        let keysArray = key.split(".");
        let field = payloadDatas;
        let lastKey = keysArray.pop();
        for (const k of keysArray) {
          if (k.includes("[") && k.includes("]")) {
            const arrayKey = k.split("[")[0];
            const index = parseInt(k.match(/\d+/)?.[0] || "0", 10);
            field = field?.[arrayKey]?.[index] ?? undefined;
          } else {
            field = field?.[k] ?? undefined;
          }
        }

        if (field && lastKey && Array.isArray(field[lastKey]) && field[lastKey][0]) {
          if (field[lastKey][0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[lastKey][0].originFileObj);
            formData.append("application", "CORPORATE");

            const res: any = await post("management/upload-file", formData);

            if (res) {
              field[lastKey] = res.response.data;
            }
          } else if (field[lastKey][0].url) {
            field[lastKey] = field[lastKey][0].url;
          }
        }
      } catch (error) {
        console.error("Error updating image field:", key, error);
      }
    }
    console.log("payloadatasssssssss", payloadDatas);

    if (payloadDatas.field_content_english) {
      payloadDatas.field_content_english = JSON.stringify(payloadDatas.field_content_english);
    }
    if (payloadDatas.field_content_malay) {
      payloadDatas.field_content_malay = JSON.stringify(payloadDatas.field_content_malay);
    }
    if (payloadDatas.field_content_mandarin) {
      payloadDatas.field_content_mandarin = JSON.stringify(payloadDatas.field_content_mandarin);
    }

    let payload = {
      action: action,
      method: method,
      module: "Sustainability",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}_${query?.get("thirdChildActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Sustainability_Memorable Airport Experiences",
      payload: payloadDatas,
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => ({
    label,
    key,
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
        }
        defaultReviewNotes="Kindly review this Sustainability"
      />
    ),
  });

  const profileChildItems = profileData
    ? profileData?.[0]?.field_content_english?.data?.siderData.filter(Boolean).map((item: any, index: any) => {
        console.log("indexitemfornow", item, index);
        const uniqueKey = `${toUniqueKey(item.title)}ForMemorableAirportExperiences_${index}`;
        return generateFormItem(
          item.title,
          uniqueKey,
          createFormConfig(item.title, [index], fieldData?.memorableAirportExperiencesSiderData?.[index]),
          `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "103"}`
        );
      })
    : (() => {
        const fieldContent = profileDataById?.payload?.field_content_english;
        let parsedContent;
        // Validate and safely parse JSON
        if (typeof fieldContent === "string") {
          try {
            parsedContent = JSON.parse(fieldContent);
          } catch (error) {
            console.error("Failed to parse field_content_english:", error);
            parsedContent = null;
          }
        } else if (typeof fieldContent === "object" && fieldContent !== null) {
          parsedContent = fieldContent;
        } else {
          parsedContent = null;
        }
        console.log("parsedContent", parsedContent, fieldContent);
        return (
          parsedContent?.data?.siderData?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toUniqueKey(item.title)}ForMemorableAirportExperiences_${index}`;
            console.log("profileChildItems", item, uniqueKey);
            console.log(
              "generateformvalue",
              createFormConfig(item.title, [index], fieldData?.memorableAirportExperiencesSiderData?.[index])
            );
            return generateFormItem(
              item?.title,
              uniqueKey,
              createFormConfig(item?.title, [index], fieldData?.memorableAirportExperiencesSiderData?.[index]),
              `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "103"}`
            );
          }) || []
        );
      })();

  return (
    <>
      <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={profileChildItems}
        onChange={(activeKey) => {
          navigate(
            `${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${query.get("subActiveTab")}&thirdChildActiveTab=${activeKey}`
          );
        }}
      ></Tabs>
    </>
  );
};
